import * as yup from 'yup'
import { IntlShape, defineMessages } from 'react-intl'
import { IPartnerSettingsFormValues } from 'features/Vehicles/types'

const externalIDMessages = defineMessages({
  required: {
    id: 'vehiclesV2.form.step1.partnerVehicleId.required',
    defaultMessage: 'This field is required'
  },
  max: {
    id: 'vehiclesV2.form.step1.partnerVehicleId.max',
    defaultMessage: 'This field must be at most {max} characters'
  }
})

const partnerMessages = defineMessages({
  required: {
    id: 'vehiclesV2.form.step1.partner.required',
    defaultMessage: 'This field is required'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IPartnerSettingsFormValues> => {
  const validations = {
    externalID: yup.string().max(128, ({ max }) => intl.formatMessage(externalIDMessages.max, { max })),
    partner: yup.object().shape({
      name: yup.string().required(),
      id: yup.string().required(intl.formatMessage(partnerMessages.required))
    }),
    drivers: yup.array().of(
      yup.object().shape({
        id: yup.string().required(),
        name: yup.string().required()
      })
    )
  }

  return yup.object().shape(validations)
}
